import React from 'react';

import PropTypes from 'prop-types';

import { useShoppingCartAndWishlist } from 'javascripts/hooks/use-shopping-cart-and-wishlist';
import { ShoppingCartContext } from 'javascripts/contexts/shopping_cart_context';

export function CartWrapper({ children }) {
  const { cartActions, renderFullShoppingCartModal, renderAddedToCartModal } = useShoppingCartAndWishlist(); // # ignore, this is the main usage of useShoppingCartAndWishlist that should trickle down through most apps

  return (
    <ShoppingCartContext.Provider value={cartActions}>
      {children}
      {renderFullShoppingCartModal()}
      {renderAddedToCartModal()}
    </ShoppingCartContext.Provider>
  );
}

CartWrapper.propTypes = {
  children: PropTypes.node,
};
